export const HomeIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 13.173C3.5 11.9466 4.06255 10.7881 5.02625 10.0296L12.7894 3.9202C14.9665 2.20687 18.0335 2.20687 20.2106 3.9202L27.9737 10.0296C28.9375 10.7881 29.5 11.9466 29.5 13.173V25C29.5 27.2091 27.7091 29 25.5 29H7.5C5.29086 29 3.5 27.2091 3.5 25V13.173Z"
      fill="currentColor"
    />
  </svg>
);
